/**
 * Shared auth call-to-action labels used wherever a guest is offered both a
 * sign-up and a sign-in path (the Pro paywall's guest state and the signed-out
 * Discover landing). Defined once so the two surfaces never drift (shared-string
 * rule): a guest always sees the same "create account" / "sign in" wording.
 */
export enum AuthCta {
  /** Primary guest action — create a new free account. */
  CreateAccount = 'Create free account',
  /** Secondary guest action — the user already has an account. */
  SignIn = 'Sign in',
  /** Opens the current provider-backed plan and offer selection. */
  ViewProPlans = 'See Pro plans',
}
